var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconLogout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 2.66536C3.15717 2.66536 2.9876 2.7356 2.86258 2.86063C2.73756 2.98565 2.66732 3.15522 2.66732 3.33203V12.6654C2.66732 12.8422 2.73756 13.0117 2.86258 13.1368C2.9876 13.2618 3.15717 13.332 3.33398 13.332H6.00065C6.36884 13.332 6.66732 13.6305 6.66732 13.9987C6.66732 14.3669 6.36884 14.6654 6.00065 14.6654H3.33398C2.80355 14.6654 2.29484 14.4547 1.91977 14.0796C1.5447 13.7045 1.33398 13.1958 1.33398 12.6654V3.33203C1.33398 2.8016 1.5447 2.29289 1.91977 1.91782C2.29484 1.54274 2.80355 1.33203 3.33398 1.33203H6.00065C6.36884 1.33203 6.66732 1.63051 6.66732 1.9987C6.66732 2.36689 6.36884 2.66536 6.00065 2.66536H3.33398ZM10.1959 4.19396C10.4563 3.93361 10.8784 3.93361 11.1387 4.19396L14.4721 7.52729C14.7324 7.78764 14.7324 8.20975 14.4721 8.4701L11.1387 11.8034C10.8784 12.0638 10.4563 12.0638 10.1959 11.8034C9.93556 11.5431 9.93556 11.121 10.1959 10.8606L12.3912 8.66536H6.00065C5.63246 8.66536 5.33398 8.36689 5.33398 7.9987C5.33398 7.63051 5.63246 7.33203 6.00065 7.33203H12.3912L10.1959 5.13677C9.93556 4.87642 9.93556 4.45431 10.1959 4.19396Z",
    fill: "#E10D0D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/iconLogout.ad2477b4ae40bda8359586778a2745d8.svg";
export { ForwardRef as ReactComponent };